/* ============================================================
   HOV SEARCH CONCERNS — health-concern matching for search
   "fat", "daibities", "kabz", "healthy organic supplement" → the products
   whose own benefit claims (metafields + description) match that concern.
   Data: /collections/all?view=hov-search-index (templates/collection.hov-search-index.liquid)
   Exposes window.HOVConcerns — used by assets/hov-search-overlay.js.
   ============================================================ */

(function () {
  'use strict';

  var INDEX_URL = '/collections/all?view=hov-search-index';
  var CACHE_KEY = 'hov_search_index_v1';
  var CACHE_TTL = 6 * 60 * 60 * 1000; // 6 hours

  // aliases  = what shoppers type (English, Hindi/Hinglish). Misspellings are handled by the matcher.
  // triggers = phrases in a product's own text that mean "helps with this". A trailing * matches
  //            any word starting with it ("immun*" → immunity, immune); otherwise whole words only,
  //            so "colds" never matches "cold-pressed" and "weight loss" never matches "net weight".
  // pin      = handles always listed first. exclude = handles never listed, and hidden from results.
  // Labels avoid treatment claims — product pages make none for these concerns.
  var CONCERNS = [
    { id: 'weight', label: 'Weight management',
      aliases: ['fat', 'fat loss', 'fat burn', 'fat burner', 'fat burning', 'belly fat', 'body fat', 'weight', 'weight loss',
        'lose weight', 'weight management', 'weight control', 'slim', 'slimming', 'obesity', 'obese', 'overweight',
        'metabolism', 'motapa', 'vajan', 'vajan kam', 'मोटापा', 'वजन'],
      triggers: ['weight loss', 'weight management', 'lose weight', 'fat burn*', 'burn fat', 'body fat',
        'fat metabolism', 'metabol*', 'low in calories'],
      pin: ['fat-burn-tea'] },
    { id: 'sugar', label: 'Sugar-conscious picks',
      aliases: ['diabetes', 'diabetic', 'diabetic friendly', 'blood sugar', 'sugar control', 'sugar level', 'sugar patient',
        'high sugar', 'sugar free', 'sugarfree', 'no sugar', 'glucose', 'insulin', 'low gi', 'low glycemic', 'glycemic',
        'madhumeh', 'sugar ki bimari', 'मधुमेह', 'शुगर'],
      triggers: ['blood sugar', 'blood glucose', 'glucose', 'glycemic', 'glycaemic', 'insulin'],
      pin: ['organic-foxtail-millet-500g', 'organic-finger-millet-ragi-500g', 'organic-sorghum-millet-jowar-500g',
        'house-of-veda-organic-khapli-wheat-flour-1kg-protein-and-fibre-rich',
        'certified-organic-psyllium-whole-husk-organic-isabgol', 'organic-moringa-powder', 'fat-burn-tea',
        'green-tea-25-bags-colds-coughs-stress-relieving-rich-in-antioxidants-certified-organic-tea-bags',
        'tulsi-green-tea-25-tea-bags-boosts-metabolism-antioxidant-rich-certified-organic-helps-in-digestion-stress-relieving'],
      exclude: ['organic-jaggery-powder-900-gms', 'house-of-veda-organic-raw-sugar-500g',
        'organic-wild-forest-honey-250g-raw-organic',
        'tulsi-green-tea-honey-lemon-25-tea-bags-stress-relieving-antioxidant-rich-certified-organic-helps-in-digestion'] },
    { id: 'immunity', label: 'Immunity',
      aliases: ['immunity', 'immune', 'immunity booster', 'immune booster', 'boost immunity', 'immune system',
        'rog pratirodhak', 'rog pratirodhak shakti', 'इम्युनिटी', 'रोग प्रतिरोधक'],
      triggers: ['immun*'] },
    { id: 'digestion', label: 'Digestion & gut health',
      aliases: ['digestion', 'digestive', 'gut', 'gut health', 'constipation', 'acidity', 'gas', 'bloating', 'indigestion',
        'stomach', 'stomach ache', 'laxative', 'kabz', 'kabj', 'pet dard', 'पाचन', 'कब्ज'],
      triggers: ['digest*', 'gut', 'constipat*', 'acidity', 'bloat*', 'laxative', 'stomach'] },
    { id: 'stress', label: 'Stress & sleep',
      aliases: ['stress', 'stress relief', 'anxiety', 'calm', 'calming', 'relax', 'relaxation', 'sleep', 'insomnia',
        'tension', 'focus', 'memory', 'neend', 'tanav', 'नींद', 'तनाव'],
      triggers: ['stress*', 'anxi*', 'calm*', 'relax*', 'sleep', 'memory', 'focus', 'clarity'] },
    { id: 'energy', label: 'Energy & stamina',
      aliases: ['energy', 'stamina', 'strength', 'weakness', 'fatigue', 'tired', 'tiredness', 'vitality', 'power',
        'endurance', 'vigour', 'vigor', 'kamzori', 'taqat', 'thakan', 'कमजोरी', 'ताकत'],
      triggers: ['stamina', 'strength*', 'vitality', 'energ*', 'tiredness', 'fatigue', 'endurance', 'vigo*'] },
    { id: 'heart', label: 'Heart & cholesterol',
      aliases: ['cholesterol', 'heart', 'heart health', 'bp', 'blood pressure', 'hypertension', 'cardiac', 'ldl',
        'triglycerides', 'कोलेस्ट्रॉल'],
      triggers: ['cholesterol', 'heart', 'cardio*', 'blood pressure'] },
    { id: 'women', label: "Women's wellness",
      aliases: ['women', 'woman', 'womens', 'women health', 'womens health', 'women wellness', 'womens wellness', 'ladies',
        'periods', 'period pain', 'period cramps', 'cramps', 'menstrual', 'menstruation', 'pcos', 'pcod', 'hormonal',
        'hormone', 'mahavari'],
      triggers: ['women', 'womens', 'menstru*', 'hormon*', 'pcos', 'pcod'] },
    { id: 'cough', label: 'Cough & cold',
      aliases: ['cough', 'cold', 'cough and cold', 'cold and cough', 'sore throat', 'throat', 'flu', 'congestion',
        'khansi', 'zukam', 'jukam', 'sardi', 'खांसी', 'जुकाम'],
      triggers: ['cough*', 'colds', 'throat', 'respirat*'] },
    { id: 'detox', label: 'Detox',
      aliases: ['detox', 'detoxification', 'cleanse', 'cleansing', 'toxins', 'liver', 'liver detox'],
      triggers: ['detox*', 'cleans*', 'toxin*', 'liver'] },
    { id: 'protein', label: 'Protein & fitness',
      aliases: ['protein', 'high protein', 'protein rich', 'gym', 'muscle', 'muscle gain', 'fitness', 'workout',
        'bodybuilding'],
      triggers: ['protein', 'muscle', 'fitness'] },
    { id: 'supplements', label: 'Ayurvedic supplements',
      aliases: ['supplement', 'supplements', 'health supplement', 'ayurvedic supplement', 'herbal supplement',
        'nutraceutical', 'nutraceuticals', 'superfood', 'herbal powder'],
      triggers: ['supplement*'],
      pin: ['pure-himalayan-shilajit', 'organic-moringa-powder', 'certified-organic-triphala-powder',
        'certified-organic-psyllium-whole-husk-organic-isabgol'] },
    { id: 'gluten', label: 'Gluten-free',
      aliases: ['gluten free', 'glutenfree', 'gluten', 'celiac', 'coeliac'],
      triggers: ['gluten free'],
      pin: ['organic-foxtail-millet-500g', 'organic-finger-millet-ragi-500g', 'organic-sorghum-millet-jowar-500g'] }
  ];

  // Product phrases that contain a concern word but are not a concern ("cold pressed oil").
  var NOT_CONCERNS = ['cold pressed', 'cold press'];

  // Sentences that warn rather than claim ("Jaggery is still a form of sugar… consult") never count.
  var CAUTION = /\b(consult|not suitable|avoid|should not|not recommended|still a form of sugar|caution|warning|allerg)/i;

  // ── TEXT HELPERS ────────────────────────────────────────────
  function norm(s) {
    return String(s || '').toLowerCase().replace(/[’']/g, '')
      .replace(/[^a-z0-9ऀ-ॿ]+/g, ' ').trim();
  }
  // Phonetic key: first letter + consonants, so "daibities" and "diabetes" both become "dbts".
  function skeleton(w) {
    w = w.replace(/ph/g, 'f').replace(/[cq]/g, 'k').replace(/z/g, 's').replace(/w/g, 'v');
    return (w.charAt(0) + w.slice(1).replace(/[aeiouyh]/g, '')).replace(/(.)\1+/g, '$1');
  }
  // Optimal string alignment distance, capped: returns max+1 as soon as it is exceeded.
  function distance(a, b, max) {
    if (Math.abs(a.length - b.length) > max) return max + 1;
    var prev2 = null, prev = [], cur, i, j;
    for (j = 0; j <= b.length; j++) prev[j] = j;
    for (i = 1; i <= a.length; i++) {
      cur = [i];
      var rowMin = i;
      for (j = 1; j <= b.length; j++) {
        var cost = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
        var v = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + cost);
        if (prev2 && i > 1 && j > 1 && a.charAt(i - 1) === b.charAt(j - 2) && a.charAt(i - 2) === b.charAt(j - 1)) {
          v = Math.min(v, prev2[j - 2] + 1);
        }
        cur[j] = v;
        if (v < rowMin) rowMin = v;
      }
      if (rowMin > max) return max + 1;
      prev2 = prev; prev = cur;
    }
    return prev[b.length];
  }

  // ── LOOKUP TABLES (hashmaps, built once) ────────────────────
  var byId = new Map();        // concern id → concern
  var aliasMap = new Map();    // normalized alias phrase → concern id
  var skeletonMap = new Map(); // phonetic key of single-word aliases (5+ letters) → concern id
  var fuzzyWords = [];         // single-word aliases (5+ letters) for the edit-distance fallback
  NOT_CONCERNS.forEach(function (p) { aliasMap.set(norm(p), null); });
  CONCERNS.forEach(function (c) {
    byId.set(c.id, c);
    c.excluded = new Set(c.exclude || []);
    c.aliases.forEach(function (a) {
      var n = norm(a);
      if (!aliasMap.has(n)) aliasMap.set(n, c.id);
      if (n.indexOf(' ') === -1 && n.length >= 5 && /^[a-z]+$/.test(n)) {
        var k = skeleton(n);
        if (k.length >= 3 && !skeletonMap.has(k)) skeletonMap.set(k, c.id);
        fuzzyWords.push({ w: n, id: c.id });
      }
    });
  });

  // ── DETECTION: query → up to 2 concerns ─────────────────────
  function detect(q) {
    var words = norm(q).split(' ').filter(Boolean);
    var found = [], used = [];
    function add(id, pos) {
      if (!id) return;
      for (var f = 0; f < found.length; f++) if (found[f].id === id) return;
      found.push({ id: id, pos: pos });
    }
    // 1. Exact phrases, longest first (O(1) map lookups). A null entry claims its words without a concern.
    for (var n = Math.min(3, words.length); n >= 1; n--) {
      for (var i = 0; i + n <= words.length; i++) {
        if (used.slice(i, i + n).some(Boolean)) continue;
        var phrase = words.slice(i, i + n).join(' ');
        if (aliasMap.has(phrase)) {
          add(aliasMap.get(phrase), i);
          for (var k = i; k < i + n; k++) used[k] = true;
        }
      }
    }
    // 2. Misspelled single words: phonetic key, then edit distance (first letter must match).
    words.forEach(function (w, idx) {
      if (used[idx] || w.length < 5 || !/^[a-z]+$/.test(w)) return;
      var id = skeletonMap.get(skeleton(w));
      if (!id) {
        var max = w.length >= 8 ? 2 : 1, best = max + 1;
        fuzzyWords.forEach(function (f) {
          if (f.w.charAt(0) !== w.charAt(0)) return;
          var d = distance(w, f.w, max);
          if (d < best) { best = d; id = f.id; }
        });
        if (best > max) id = null;
      }
      add(id, idx);
    });
    found.sort(function (a, b) { return a.pos - b.pos; }); // in the order the shopper typed them
    return found.slice(0, 2).map(function (f) { var c = byId.get(f.id); return { id: c.id, label: c.label }; });
  }

  // ── CLASSIFICATION: concern → ranked products (once per index) ─
  var lists = null; // Map<concern id, product[]>
  var texts = null; // Map<handle, normalized searchable text> for query-aware ordering

  function hasTrigger(text, trig) {
    if (trig.charAt(trig.length - 1) === '*') return text.indexOf(' ' + trig.slice(0, -1)) !== -1;
    return text.indexOf(' ' + trig + ' ') !== -1;
  }

  function classify(index) {
    var byHandle = new Map();
    texts = new Map();
    var prepared = index.map(function (p, order) {
      byHandle.set(p.h, p);
      var desc = String(p.d || '').split(/[.!?•\n]+/).filter(function (s) { return !CAUTION.test(s); }).join(' ');
      var x = {
        p: p, order: order,
        head: ' ' + norm(p.t + ' ' + (p.ty || '') + ' ' + (p.tg || []).join(' ')) + ' ',
        ben: ' ' + norm(p.b) + ' ',
        desc: ' ' + norm(desc) + ' '
      };
      texts.set(p.h, x.head + x.ben + x.desc);
      return x;
    });
    var out = new Map();
    CONCERNS.forEach(function (c) {
      var triggers = c.triggers.map(function (t) {
        var star = t.charAt(t.length - 1) === '*';
        return norm(star ? t.slice(0, -1) : t) + (star ? '*' : '');
      });
      var scored = [];
      prepared.forEach(function (x) {
        if (c.excluded.has(x.p.h)) return;
        var s = 0;
        triggers.forEach(function (t) {
          if (hasTrigger(x.head, t)) s += 4;  // title, type, tags ("Immune Tea" for immunity)
          if (hasTrigger(x.ben, t)) s += 3;   // the store's own benefit claims
          if (hasTrigger(x.desc, t)) s += 1;  // description (warnings removed)
        });
        if (s > 0) scored.push({ p: x.p, s: s, order: x.order });
      });
      scored.sort(function (a, b) {
        return (b.s - a.s) || ((b.p.a ? 1 : 0) - (a.p.a ? 1 : 0)) || (a.order - b.order);
      });
      var listed = [], seen = new Set();
      (c.pin || []).forEach(function (h) {
        var p = byHandle.get(h);
        if (p && !c.excluded.has(h) && !seen.has(h)) { seen.add(h); listed.push(p); }
      });
      scored.forEach(function (x) { if (!seen.has(x.p.h)) { seen.add(x.p.h); listed.push(x.p); } });
      out.set(c.id, listed);
    });
    return out;
  }

  // ── INDEX LOADING (lazy, cached) ────────────────────────────
  var inflight = null;

  function readCache() {
    try {
      var c = JSON.parse(localStorage.getItem(CACHE_KEY) || 'null');
      if (c && Array.isArray(c.d) && Date.now() - c.t < CACHE_TTL) return c.d;
    } catch (e) {}
    return null;
  }
  function writeCache(data) {
    try { localStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), d: data })); } catch (e) {}
  }
  function fetchIndex() {
    return fetch(INDEX_URL, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('index ' + r.status);
      return r.json();
    }).then(function (data) {
      if (!Array.isArray(data)) throw new Error('index: unexpected response');
      return data;
    });
  }

  function load() {
    if (lists) return Promise.resolve();
    if (inflight) return inflight;
    var cached = readCache();
    if (cached) { lists = classify(cached); return Promise.resolve(); }
    inflight = fetchIndex()
      .catch(function () { // one quiet retry
        return new Promise(function (resolve) { setTimeout(resolve, 800); }).then(fetchIndex);
      })
      .then(function (data) {
        writeCache(data);
        lists = classify(data);
        inflight = null;
      }, function (err) {
        inflight = null; // allow a later retry
        throw err;
      });
    return inflight;
  }

  window.HOVConcerns = {
    detect: detect,
    load: load,
    ready: function () { return !!lists; },
    // With q, products that mention a typed word ("constipation", "sleep") move to the front.
    products: function (id, q) {
      var list = (lists && lists.get(id)) || [];
      var words = q ? norm(q).split(' ').filter(function (w) { return w.length >= 4; }) : [];
      if (!words.length) return list;
      var hit = [], rest = [];
      list.forEach(function (p) {
        var t = texts.get(p.h) || '';
        (words.some(function (w) { return t.indexOf(' ' + w) !== -1; }) ? hit : rest).push(p);
      });
      return hit.concat(rest);
    },
    isExcluded: function (id, handle) { var c = byId.get(id); return !!(c && c.excluded.has(handle)); }
  };
})();
